import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const DBA = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.dba"
      control={control}
      render={({ field }) => (
        <FF2
          label="87. Alternate name"
          field={field}
          input={(props) => <TextInput {...props} maxLength={9} data-qa="87. Alternate name" />}
        />
      )}
    />
  )
}
